import { TConditionalHelperDependencies } from '@kurtosys/types/helpers/TConditionalHelperDependencies.js';
import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';

import { helpers } from '../../common/index.js';
import { getQueryClass } from '../queryUtils/getQueryClass.js';

import { BaseTransform } from './BaseTransform.js';

export class SwitchTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions): any {
		const { switchOptions } = this.options;

		if (switchOptions) {
			const { defaultResponse, cases, useValueAsResponse = false } = switchOptions;
			let response: any = defaultResponse;
			if (useValueAsResponse) {
				response = queryResponse;
			}
			for (const caseInstance of cases) {
				const {
					conditional,
					response: caseResponseStatic,
					responseQuery: caseResponseQuery,
					value,
				} = caseInstance;
				let caseResponse = caseResponseStatic;
				if (caseResponseQuery) {
					const query = getQueryClass(this.dependencies, caseResponseQuery, this.translationHelper)
					if (query) {
						caseResponse = query.execute(executionOptions);
					}
				}

				if (value) {
					if (queryResponse === value) {
						response = caseResponse;
						break;
					}
				} else if (conditional) {
					const conditionalHelperDependencies: TConditionalHelperDependencies = {
						queryClass: this.dependencies.queryClass,
					};
					const conditionalHelper = new helpers.ConditionalHelper(
						conditionalHelperDependencies,
						conditional,
						this.translationHelper,
					);
					if (
						conditionalHelper.matchesWithOptions({
							executionOptions,
							instance: queryResponse,
						})
					) {
						response = caseResponse;
						break;
					}
				}
			}
			return response;
		}

		return;
	}
}
